import { useCallSessionRoomStore } from '@/entities/call-session'
import { useStoreConferenceMediaStatuses } from '@/entities/conference-participant'

type SessionMicReleaseState = {
  sessionId: string
  callId: { value: string }
  isOnHold: { value: boolean }
  isMuted: { value: boolean }
}

/**
 * True when local mic capture must stay stopped (mute / hold).
 * Push-to-talk local mute keeps the stream live and is not treated as released.
 */
export const isLocalMicCaptureReleased = (session: SessionMicReleaseState): boolean => {
  if (session.isOnHold.value) {
    return true
  }

  const room = useCallSessionRoomStore().getRoom(session.sessionId)
  if (room?.isGroup) {
    return Boolean(
      useStoreConferenceMediaStatuses().getParticipantMediaStatus(session.callId.value)?.isAudioMuted,
    )
  }

  return session.isMuted.value
}
